import React from 'react';
import PageTransition from '../components/PageTransition';
import './LegalPages.css';

function ShippingPolicyPage() {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1>Shipping Policy</h1>

                <section className="legal-section">
                    <p>We aim to bring the divine blessings of the temple to your doorstep as quickly as possible.</p>
                </section>

                <section className="legal-section">
                    <h2>Processing Time</h2>
                    <p>After the Pooja/Archana is performed, the Prasadam is typically dispatched within 24–48 hours.</p>
                </section>

                <section className="legal-section">
                    <h2>Delivery Timeline</h2>
                    <div className="shipping-timeline">
                        <p><strong>Domestic (India):</strong> 3 to 7 business days depending on the location.</p>
                        <p><strong>International:</strong> 10 to 15 business days. Please note that international shipping may incur additional customs charges or delays beyond our control.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>Shipping Charges</h2>
                    <p>Shipping costs are calculated at checkout based on the weight of the Prasadam and the delivery destination.</p>
                </section>

                <section className="legal-section">
                    <h2>Tracking System</h2>
                    <p>Once dispatched, a tracking ID will be sent to your registered email or mobile number via SMS/WhatsApp.</p>
                </section>

                <section className="legal-section">
                    <h2>Perishables</h2>
                    <p>Please note that certain Prasadam items (like flowers or cooked food) may be excluded from long-distance shipping to maintain hygiene and quality; only non-perishable items like Vibhuti, Kumkum, or dry fruits will be sent.</p>
                </section>
            </div>
        </div>
    );
}

export default PageTransition(ShippingPolicyPage);
